import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  centered = true,
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${centered ? 'text-center' : 'text-left'}`} data-id="element-101" data-mp="3f2n73y24osr0">
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold font-serif mb-4 ${light ? 'text-white' : 'text-[#0A0A0A]'}`} data-id="element-102" data-mp="3k187pylalefz">
        {title}
      </h2>
      {subtitle && <div className="flex flex-col items-center" data-id="element-103" data-mp="gjq09s9fm9g3">
          <div className="w-24 h-1 bg-[#C5A55A] mb-6" data-id="element-104" data-mp="gljcdn2tdlvh" />
          <p className={`text-lg max-w-2xl mx-auto ${light ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-105" data-mp="1titwawp8gvr">
            {subtitle}
          </p>
        </div>}
      {!subtitle && centered && <div className="w-24 h-1 bg-[#C5A55A] mx-auto mt-4" data-id="element-106" data-mp="uhoduvfxi1uj" />}
      {!subtitle && !centered && <div className="w-24 h-1 bg-[#C5A55A] mt-4" data-id="element-107" data-mp="zapsr3g4y1e4" />}
    </div>;
}